// @mui
import { List, Stack } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
// types
import { NavSectionProps } from '../types';
import { StyledSubheader } from './styles';
import NavList from './NavList';
import { useGetUser } from 'src/hooks/useGetUser';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
  const { translate } = useLocales();
  const user = useGetUser(); // Fetch the current user

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.subheader || group.items[0].title;

        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.subheader && (
              <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>
            )}

            {/* Map over group.items with conditional rendering */}
            {group.items.map((list: any) => {
              // Render NavList if the item is not private or if the user is an admin
              if (!list.private || (user && user.role.toLowerCase() === 'admin')) {
                return (
                  <NavList
                    key={list.title + list.path}
                    data={list}
                    depth={1}
                    hasChild={!!list.children}
                  />
                );
              }
              // Otherwise return null (don't render)
              return null;
            })}
          </List>
        );
      })}
    </Stack>
  );
}
